<template>
  <div>
    <stepForm
      :user="user"
      :request="request"
      :request-buttons="requestButtons"
      :btn-position="btnPosition"
      @click="showHistory = !showHistory"
      @input="$emit('input')"
    ></stepForm>
    <div v-if="showHistory" class="mt-3">
      <history-simple-absence />
    </div>
  </div>
</template>

<script>
import stepForm from '@/components/shared/stepForm';

export default {
  name: 'StepOneSimple',
  components: {
    HistorySimpleAbsence: () =>
      import('../../abscenceRequest/HistorySimpleAbsence'),
    stepForm,
  },

  props: ['user'],
  data() {
    return {
      showHistory: false,
    };
  },
  computed: {
    request() {
      const requestData = {
        requestFor: this.$t('simple.absence.request.for'),
        title: this.$t('simple.absence.request.step.one.title'),
        description: this.$t('simple.absence.request.step.one.description'),
        videoUrl: this.$t('simple.video.url'),
      };
      return requestData;
    },

    requestButtons() {
      const requestBtns = {
        next: this.$t('global.next'),
        history: this.$t('global.history'),
      };
      return requestBtns;
    },

    btnPosition() {
      const buttonStyle = {
        btnHistoryClass: 'btn-wrapper d-flex justify-content-between',
        btnClass: 'ml-md-auto mr-md-0 mx-auto',
      };
      return buttonStyle;
    },
  },
};
</script>

<style scoped></style>
